@let obs =
  {
    transitInstance: transitInstance$ | async,
    transitInstanceSwitchState: (transitInstance$ | async)?.switchState$ | async,
    desktopWishlistVisible: desktopWishlistVisible$ | async,
    desktopComparisonVisible: desktopComparisonVisible$ | async,
    isDesktop: isDesktop | async,
    prices: prices$ | async,
    hasPersonalPrice: hasPersonalPrice$ | async,
    bonuses: bonuses$ | async,
    isTabletUp: isTabletUp$ | async,
  };

<div class="product-item-wrapper" [class.desktop-mode]="obs.isDesktop">
  <div
    class="product"
    [class.desktop-wishlist-visible]="obs.desktopWishlistVisible"
    [class.desktop-comparison-visible]="obs.desktopComparisonVisible"
  >
    <sd-product-item-upper-buttons
      data-ignore-product-details-redirect="true"
      [productCode]="product.code"
      [hideWishlist]="hideWishlist"
      class="upper-buttons"
    ></sd-product-item-upper-buttons>
    <div class="image-section">
      <sd-product-list-image
        [product]="product"
        (clickImage)="onLinkClick()"
        [width]="250"
        [height]="250"
        [loadImageEagerly]="productIndex !== undefined && productIndex < 3"
      ></sd-product-list-image>
      @defer (on idle) {
        @if (obs.isTabletUp === false) {
          <sd-product-button-mobile
            class="buy-section-mobile ignore-product-link"
            (click)="onAddToCart()"
            data-testid="addToCardButton"
            [product]="product"
            [productIndex]="productIndex"
          ></sd-product-button-mobile>
        }
      } @placeholder {
        <div class="buy-section-mobile buy-section-mobile--defer-ph" aria-hidden="true"></div>
      }
    </div>
    <div class="title-section">
      <div
        class="rating"
        [routerLink]="!obs.isDesktop ? ({ cxRoute: 'product', params: product } | cxUrl) : null"
        (click)="!obs.isDesktop && onLinkClick()"
      >
        @if (rating$ | async; as rating) {
          <span class="rating-icon"><sd-icon type="star"></sd-icon></span>
          <span class="rating-score text-b4-s-500 text-xs-c2-m-300 text-md-c1-l-300 text-lg-b4-m-300">
            {{ rating }}
          </span>
        }
      </div>

      <div class="title">
        <a
          class="text-b4-s-500 text-xs-b3-s-500 text-md-b2-s-500 text-lg-b1-s-500"
          [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
          (click)="onLinkClick()"
        >
          {{ product.name }}
        </a>
      </div>
    </div>

    <div
      class="price-section"
      [routerLink]="!obs.isDesktop ? ({ cxRoute: 'product', params: product } | cxUrl) : null"
      (click)="!obs.isDesktop && onLinkClick()"
    >
      <div class="price-section-inner">
        <div class="price-row">
          <div class="prices">
            @let isNotAvailable = !(product && (product | sdProductIsAvailable));
            @if (obs.prices) {
              @if (obs.transitInstance) {
                <div (click)="$event.stopPropagation()">
                  <sd-product-price-transit
                    class="ignore-product-link"
                    data-testid="transitPrice"
                    [prices]="obs.prices"
                    [isNotAvailable]="isNotAvailable"
                    [transitState]="obs.transitInstanceSwitchState"
                    (switchPrice)="obs.transitInstance?.setState($event)"
                  ></sd-product-price-transit>
                </div>
              } @else {
                <sd-product-price-available
                  data-testid="regularPrice"
                  [prices]="obs.prices"
                  [isRentProduct]="product.isRent"
                ></sd-product-price-available>
              }
            }
          </div>
          @if ((!obs.transitInstance || obs.transitInstanceSwitchState === false) && obs.bonuses) {
            <div class="bonuses">
              <div class="d-flex align-items-center">
                <sd-bonus-widget
                  [isPromo]="obs.bonuses.type === BonusTypes.PROMO_BONUS"
                  [amount]="obs.bonuses.formattedValue"
                ></sd-bonus-widget>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="buy-section">
      <div class="buy-button">
        @if (
          (!obs.transitInstance || obs.transitInstanceSwitchState === false) &&
          product.units &&
          (product | sdProductIsAvailable)
        ) {
          <div class="units">
            <sd-unit-tab
              class="ignore-product-link"
              data-testid="unitTabs"
              [units]="product.units"
              [productCode]="product.code"
            ></sd-unit-tab>
          </div>
        }
        <div class="add-to-cart">
          @defer (on idle) {
            @if (obs.transitInstance && obs.transitInstanceSwitchState) {
              <sd-transit-order-request
                class="ignore-product-link"
                data-testid="transitOrderButton"
                [product]="product"
              ></sd-transit-order-request>
            } @else if (obs.isTabletUp === true) {
              <sd-product-button
                class="product-button-add-to-cart ignore-product-link"
                (click)="onAddToCart()"
                data-testid="addToCardButton"
                [product]="product"
                [productIndex]="productIndex"
              ></sd-product-button>
            }
          } @placeholder {
            <div class="add-to-cart--defer-ph" aria-hidden="true"></div>
          }
        </div>
      </div>
      <div class="product-availability">
        @if (((product | sdProductIsAvailable) || obs.transitInstance) && obs.isDesktop) {
          <sd-product-list-availability [product]="product"></sd-product-list-availability>
        } @else {
          <div>&nbsp;</div>
          <!-- заглушка для грида -->
        }
      </div>
    </div>
  </div>

  <a
    [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
    (click)="onLinkClick()"
    class="product-overlay-link"
    [class.hidden]="obs.isDesktop"
  ></a>
</div>
